import { render, staticRenderFns } from "./add-service-wizard-access-control-triggers.vue?vue&type=template&id=b0fb8b5a&scoped=true&"
import script from "./add-service-wizard-access-control-triggers.js?vue&type=script&lang=js&"
export * from "./add-service-wizard-access-control-triggers.js?vue&type=script&lang=js&"
import style0 from "./add-service-wizard-access-control-triggers.css?vue&type=style&index=0&id=b0fb8b5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0fb8b5a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCardActions,VListItemAvatar,VListItemContent,VListItemTitle,VSelect,VTextField})
